import src from "IMAGE";
export default { src, width: 754, height: 503, blurWidth: 0, blurHeight: 0};
